/**
 * Created by dimah on 30/07/17.
 */

import { AbstractDTO } from "./abstract";

export class CustomerInquiriesGenericDTO extends AbstractDTO {

    constructor(attributes?: object) {
        attributes = attributes ? attributes : {};
        super(attributes);
    }

}